<template>
  <div id="InternationalExams">
    <v-expansion-panels v-if="needsInternaltionalChecks"   focusable class="px-2 mt-3 ">
      <v-expansion-panel class="mt-2  "  >
        <v-expansion-panel-header  class="light-blue--text text--darken-4">
          <v-layout row align-center pb-0 >
            <v-icon :color="clearInternationalChecks ? 'green' : 'red'" >mdi-check-circle</v-icon>
            <v-icon color="blue darken-3" class="ml-2">mdi-earth</v-icon>
            <span class="ml-2 blue--text text--darken-3 font-weight-medium">International Students</span>
          </v-layout>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">

          <!-- Accepted English Proficiency Exams -->
          <v-card v-if="savedSchool.toefl_required || savedSchool.ielts_required || savedSchool.melab_required || savedSchool.pteAcademic_required || savedSchool.itepAcademicPlus_required" 
            class="mt-4  pb-4 innerCardCover elevation-0"  
            style="borderRadius:5px" 
            outlined
            >
            <v-layout class="pb-2 justify-center" :class="{ red: !clearInternationalChecks, green: clearInternationalChecks }" >
              <span  class="white--text text-center mt-2">English Proficiency Exams Pending</span>
            </v-layout>
            <!-- <v-card-title class="red mt-0 pb-1">
              <span class="mb-1 subheading font-weight-regular white--text">  English Proficiency Exams Required </span>
            </v-card-title> -->

              <v-layout justify-center align-center><v-subheader class="subtitle-1"> Accepted Exams</v-subheader></v-layout>

              <!-- TOEFL IBT -->
              <v-expansion-panels v-if="savedSchool.toefl_required" focusable class="mt-1 px-2 elevation-0">
                <v-expansion-panel>
                  <v-expansion-panel-header >
                    <v-layout row align-center>
                      <v-icon :color="userClears_TOEFL_IBT  ? 'green' : 'red'"  >mdi-check-circle </v-icon>
                      <span class="ml-2 blue--text text--darken-3 font-weight-medium">TOEFL IBT</span>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content  style="borderRadius:5px;"  >

                    <v-layout
                      v-if="(savedSchool.toefl_minimum_computer_score === '' || savedSchool.toefl_minimum_computer_score === undefined) &&
                      (savedSchool.toefl_ibt_minimum_reading_score === '' || savedSchool.toefl_ibt_minimum_reading_score === undefined) &&
                      (savedSchool.toefl_ibt_minimum_writing_score === '' || savedSchool.toefl_ibt_minimum_writing_score === undefined) &&
                      (savedSchool.toefl_ibt_minimum_listening_score === '' || savedSchool.toefl_ibt_minimum_listening_score === undefined) &&
                      (savedSchool.toefl_ibt_minimum_speaking_score === '' || savedSchool.toefl_ibt_minimum_speaking_score === undefined)"
                      align-center justify-center py-2 class="grey--text white "
                      >
                      No Minimum Score Required
                  </v-layout>

                  <!-- MINIMUM TOEFL IBT SCORES -->
                  <v-layout
                    v-if="(savedSchool.toefl_minimum_computer_score !== '' && savedSchool.toefl_minimum_computer_score !== undefined) ||
                    (savedSchool.toefl_ibt_minimum_reading_score !== '' && savedSchool.toefl_ibt_minimum_reading_score !== undefined) ||
                    (savedSchool.toefl_ibt_minimum_writing_score !== '' && savedSchool.toefl_ibt_minimum_writing_score !== undefined) ||
                    (savedSchool.toefl_ibt_minimum_listening_score !== '' && savedSchool.toefl_ibt_minimum_listening_score !== undefined) ||
                    (savedSchool.toefl_ibt_minimum_speaking_score !== '' && savedSchool.toefl_ibt_minimum_speaking_score !== undefined) "
                    column class="pl-0 ml-0 "
                    >

                        <v-layout justify-center align-center class="py-2 px-2 font-weight-regular red--text"> Minimum Scores Required </v-layout>


                      <!-- Total Score -->
                      <v-layout  v-if="savedSchool.toefl_minimum_computer_score !== '' && savedSchool.toefl_minimum_computer_score !== undefined" mt-3 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Total Score</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_minimum_computer_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_minimum_computer_score !== '' && savedSchool.toefl_minimum_computer_score !== undefined"  class="mt-2 mb-1 mx-2"></v-divider>

                      <!-- Minimum IBT Reading Score -->
                      <v-layout  v-if="savedSchool.toefl_ibt_minimum_reading_score !== '' && savedSchool.toefl_ibt_minimum_reading_score !== undefined "  mt-1 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Reading</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_ibt_minimum_reading_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_ibt_minimum_reading_score !== '' && savedSchool.toefl_ibt_minimum_reading_score !== undefined "   class="mt-2 mb-1 mx-2"></v-divider>

                      <!-- Minimum IBT Written Score -->
                      <v-layout  v-if="savedSchool.toefl_ibt_minimum_writing_score !== '' && savedSchool.toefl_ibt_minimum_writing_score !== undefined "  mt-1 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Written</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_ibt_minimum_writing_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_ibt_minimum_writing_score !== '' && savedSchool.toefl_ibt_minimum_writing_score !== undefined "   class="mt-2 mb-1 mx-2"></v-divider>

                        <!-- Minimum IBT Listening Score -->
                        <v-layout  v-if="savedSchool.toefl_ibt_minimum_listening_score !== '' && savedSchool.toefl_ibt_minimum_listening_score !== undefined "  mt-1 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Listening</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_ibt_minimum_listening_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_ibt_minimum_listening_score !== '' && savedSchool.toefl_ibt_minimum_listening_score !== undefined "   class="mt-2 mb-1 mx-2"></v-divider>

                        <!-- Minimum IBT Speaking Score -->
                        <v-layout  v-if="savedSchool.toefl_ibt_minimum_speaking_score !== '' && savedSchool.toefl_ibt_minimum_speaking_score !== undefined "  mt-1 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Speaking</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_ibt_minimum_speaking_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_ibt_minimum_speaking_score !== '' && savedSchool.toefl_ibt_minimum_speaking_score !== undefined "   class="mt-2 mb-1 mx-2"></v-divider>

                  </v-layout>

                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <!-- TOEFL PBT -->
              <v-expansion-panels
                v-if="savedSchool.toefl_required "
                class="mt-3 px-2 elevation-0"
                >
                <v-expansion-panel >
                  <v-expansion-panel-header class="py-1">
                    <v-layout row align-center>
                      <v-icon :color="userClears_TOEFL_PBT ? 'green' : 'red'"  >mdi-check-circle </v-icon>
                      <span class="ml-2 blue--text text--darken-3 font-weight-medium">TOEFL PBT</span>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content  style="borderRadius:5px;">


                    <v-layout
                      v-if="(savedSchool.toefl_minimum_written_score === '' || savedSchool.toefl_minimum_written_score === undefined) &&
                      (savedSchool.toefl_pbt_minimum_reading_score === '' || savedSchool.toefl_pbt_minimum_reading_score === undefined) &&
                      (savedSchool.toefl_pbt_minimum_written_score === '' || savedSchool.toefl_pbt_minimum_written_score === undefined) &&
                      (savedSchool.toefl_pbt_minimum_listening_score === '' || savedSchool.toefl_pbt_minimum_listening_score === undefined)"
                      align-center justify-center  py-2 class="grey--text white "
                      >
                      No Minimum Score Required
                    </v-layout>

                    <!-- MINIMUM TOEFL PBT SCORES -->
                    <v-layout
                      v-if="(savedSchool.toefl_minimum_written_score !== '' && savedSchool.toefl_minimum_written_score !== undefined)||
                      (savedSchool.toefl_pbt_minimum_reading_score !== '' && savedSchool.toefl_pbt_minimum_reading_score !== undefined)||
                      (savedSchool.toefl_pbt_minimum_written_score !== '' && savedSchool.toefl_pbt_minimum_written_score !== undefined)||
                      (savedSchool.toefl_pbt_minimum_listening_score !== '' && savedSchool.toefl_pbt_minimum_listening_score !== undefined)"
                    column class="pl-0 ml-0 "
                    >

                        <v-layout justify-center align-center class=" py-2 pl-2 font-weight-regular red--text"> Minimum Scores Required </v-layout>


                      <!-- Minimum PBT Total score -->
                      <v-layout  v-if="savedSchool.toefl_minimum_written_score !== '' && savedSchool.toefl_minimum_written_score !== undefined" mt-3 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Total Score</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_minimum_written_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_minimum_written_score !== '' && savedSchool.toefl_minimum_written_score !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>

                        <!-- Minimum PDT READING score -->
                      <v-layout  v-if="savedSchool.toefl_pbt_minimum_reading_score !== '' && savedSchool.toefl_pbt_minimum_reading_score !== undefined" mt-2 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Reading</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_pbt_minimum_reading_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_pbt_minimum_reading_score !== '' && savedSchool.toefl_pbt_minimum_reading_score !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>

                        <!-- Minimum PDT WRITTEN score -->
                      <v-layout  v-if="savedSchool.toefl_pbt_minimum_written_score !== '' && savedSchool.toefl_pbt_minimum_written_score !== undefined" mt-2 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Written</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_pbt_minimum_written_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_pbt_minimum_written_score !== '' && savedSchool.toefl_pbt_minimum_written_score !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>

                        <!-- Minimum PDT LISTENING score -->
                      <v-layout  v-if="savedSchool.toefl_pbt_minimum_listening_score  !== '' && savedSchool.toefl_pbt_minimum_listening_score  !== undefined" mt-2 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Listening</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.toefl_pbt_minimum_listening_score }}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.toefl_pbt_minimum_listening_score  !== '' && savedSchool.toefl_pbt_minimum_listening_score  !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>

                    </v-layout>



                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <!-- IELTS -->
              <v-expansion-panels v-if="savedSchool.ielts_required"  class="mt-3 px-2 elevation-0">
                <v-expansion-panel >
                  <v-expansion-panel-header class="py-1">
                    <v-layout row align-center>
                      <v-icon :color="userClears_IELTS  ? 'green' : 'red'"  >mdi-check-circle </v-icon>
                      <span class="ml-2 blue--text text--darken-3 font-weight-medium">IELTS</span>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="borderRadius:5px;">

                    <v-layout
                      v-if="savedSchool.ielts_minimum_score === '' || savedSchool.ielts_minimum_score === undefined"
                      align-center justify-center py-2 class="grey--text white"
                      >
                        No Minimum Score Required
                    </v-layout>

                    <v-layout
                      v-if="savedSchool.ielts_minimum_score !== '' && savedSchool.ielts_minimum_score !== undefined "
                      column class="pl-0 ml-0 "
                      >

                        <v-layout justify-center align-center class=" py-2 pl-2 font-weight-regular red--text"> Minimum Scores Required </v-layout>


                      <!--  Total score -->
                      <v-layout  v-if="savedSchool.ielts_minimum_score !== '' && savedSchool.ielts_minimum_score !== undefined" mt-3 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Total Score</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.ielts_minimum_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.ielts_minimum_score !== '' && savedSchool.ielts_minimum_score !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>


                    </v-layout>


                    <v-list v-else subheader>

                    <v-layout>
                      <v-subheader class=" pr-0"> Minimum IELTS Scores </v-subheader>

                    </v-layout>

                      <v-list-tile v-if="savedSchool.ielts_minimum_score !== '' && savedSchool.ielts_minimum_score !== undefined " class="pl-0 ml-0">
                        <v-list-tile-title class="subheading font-weight-light pl-0 ml-0">Total Score </v-list-tile-title>
                          <v-list-tile-action >
                          <span class="ml-4 blue--text text--darken-3 "> {{savedSchool.ielts_minimum_score}}</span>
                          </v-list-tile-action>
                      </v-list-tile>
                      <v-divider v-if="savedSchool.ielts_minimum_score !== '' && savedSchool.ielts_minimum_score !== undefined" class="mx-3"></v-divider>

                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>


              <!-- MELAB -->
              <v-expansion-panels  v-if="savedSchool.melab_required"  class="mt-3 px-2 elevation-0">
                <v-expansion-panel >
                  <v-expansion-panel-header class="py-1">
                    <v-layout row align-center>
                      <v-icon :color="userClears_MELAB ? 'green' : 'red'"  >mdi-check-circle </v-icon>
                      <span class="ml-2 blue--text text--darken-3 font-weight-medium">MELAB</span>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="borderRadius:5px;">

                    <v-layout
                      v-if="savedSchool.melab_minimum_score === '' || savedSchool.melab_minimum_score === undefined"
                      align-center justify-center py-2 class="grey--text white"
                      >
                        No Minimum Score Required
                    </v-layout>

                    <v-layout
                      v-if="savedSchool.melab_minimum_score !== '' && savedSchool.melab_minimum_score !== undefined "
                      column class="pl-0 ml-0 "
                      >

                        <v-layout justify-center align-center class="py-2 pl-2 font-weight-regular red--text"> Minimum Scores Required </v-layout>


                      <!--  Total score -->
                      <v-layout  v-if="savedSchool.melab_minimum_score !== '' && savedSchool.melab_minimum_score !== undefined" mt-3 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Total Score</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.melab_minimum_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.melab_minimum_score !== '' && savedSchool.melab_minimum_score !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>


                    </v-layout>


                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>


              <!-- PTE Academic -->
              <v-expansion-panels  v-if="savedSchool.pteAcademic_required"  class="mt-3 px-2 elevation-0">
                <v-expansion-panel >
                  <v-expansion-panel-header class="py-1">
                    <v-layout row align-center>
                      <v-icon :color="userClears_PTEAcademic ? 'green' : 'red'"  >mdi-check-circle </v-icon>
                      <span class="ml-2 blue--text text--darken-3 font-weight-medium">PTE Academic</span>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="borderRadius:5px;">

                    <v-layout
                      v-if="savedSchool.pteAcademic_minimum_score === '' || savedSchool.pteAcademic_minimum_score === undefined"
                      align-center justify-center py-2 class="grey--text white"
                      >
                        No Minimum Score Required
                    </v-layout>

                    <v-layout
                      v-if="savedSchool.pteAcademic_minimum_score !== '' && savedSchool.pteAcademic_minimum_score !== undefined "
                      column class="pl-0 ml-0 "
                      >

                        <v-layout justify-center align-center class=" py-2 pl-2 font-weight-regular red--text"> Minimum Scores Required </v-layout>


                      <!--  Total score -->
                      <v-layout  v-if="savedSchool.pteAcademic_minimum_score !== '' && savedSchool.pteAcademic_minimum_score !== undefined" mt-3 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Total Score</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.pteAcademic_minimum_score}}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.pteAcademic_minimum_score !== '' && savedSchool.pteAcademic_minimum_score !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>


                    </v-layout>


                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>


              <!-- iTEP Academic-Plus -->
              <v-expansion-panels v-if="savedSchool.itepAcademicPlus_required" class="mt-3 px-2 elevation-0">
                <v-expansion-panel >
                  <v-expansion-panel-header class="py-1">
                    <v-layout row align-center>
                      <v-icon :color="userClears_iTEPAcademic ? 'green' : 'red'"  >mdi-check-circle </v-icon>
                      <span class="ml-2 blue--text text--darken-3 font-weight-medium">iTEP Academic-Plus</span>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content style="borderRadius:5px;">

                    <v-layout
                      v-if="savedSchool.itepAcademicPlus_minimum_score  === '' || savedSchool.itepAcademicPlus_minimum_score  === undefined"
                      align-center justify-center py-2 class="grey--text white"
                      >
                        No Minimum Score Required
                    </v-layout>

                    <v-layout
                      v-if="savedSchool.itepAcademicPlus_minimum_score  !== '' && savedSchool.itepAcademicPlus_minimum_score  !== undefined "
                      column class="pl-0 ml-0 "
                      >

                        <v-layout justify-center align-center class="py-2 pl-2 font-weight-regular red--text"> Minimum Scores Required </v-layout>


                      <!--  Total score -->
                      <v-layout  v-if="savedSchool.itepAcademicPlus_minimum_score  !== '' && savedSchool.itepAcademicPlus_minimum_score  !== undefined" mt-3 row   align-center justify-space-between mx-2>
                        <span class=" font-weight-light black--text ">Total Score</span>
                        <span class=" blue--text text--darken-3 "> {{savedSchool.itepAcademicPlus_minimum_score }}</span>
                      </v-layout>
                      <v-divider v-if="savedSchool.itepAcademicPlus_minimum_score  !== '' && savedSchool.itepAcademicPlus_minimum_score  !== undefined"  class="mt-1 mb-1 mx-2"></v-divider>


                    </v-layout>


                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

          </v-card>

          <!-- CONDITIONS -->
          <v-card  style="borderRadius:5px"  class="mt-5 innerCardCover elevation-0" outlined >
              <v-layout justify-center class="grey lighten-3 pb-2 ">
                <span class="subtitle-1 mt-2 font-weight-regular"> Conditions </span>
              </v-layout>

              <v-card-text class="pt-2  ">

                <v-layout >
                      <span v-if="savedSchool.toefl_minimum_years_completed !=='' && savedSchool.toefl_minimum_years_completed !== undefined" class="font-weight-light black--text">English Proficiency Exams should be completed within <span class="font-weight-medium blue--text text--darken-3">{{savedSchool.toefl_minimum_years_completed}} years</span></span>
                      <span v-else class="font-weight-light black--text">English Proficiency Exams should be completed within <span class="font-weight-medium blue--text text--darken-3">2 years</span></span>
                    </v-layout>
              </v-card-text>
          </v-card>

          <!-- EXEMPTIONS -->
          <v-card v-if="savedSchool.toefl_exempt_masters_doctoral_degrees" 
            style="borderRadius:5px"  
            class="mt-5 innerCardCover elevation-0" 
            outlined
            >
            <v-layout justify-center class=" grey lighten-3 pb-2 ">
              <span class="subtitle-1 mt-2 font-weight-regular"> Exemptions</span>
            </v-layout>

            <v-card-text class="pt-2  ">
              <v-layout  column class="pl-0 ml-0 ">

                  <!-- ENGLISH EXAMS EXEMPT WITH MASTERS OR DOCTORAL DEGREE -->
                  <v-layout   mt-2 row   align-center  mx-0>
                    <span class=" font-weight-light black--text ">TOFEL exempt with Masters or Doctoral Degree</span>
                  </v-layout>


              </v-layout>

            </v-card-text>

          </v-card>

          <!-- International Notes -->
          <v-card v-if="savedSchool.internationalExamsNotes" outlined class=" mt-4 mb-4">
            <v-layout align-center justify-center class=" pb-1" > 
              <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
              <span class="font-weight-light align-center">Additional Notes </span>
            </v-layout>
            <v-divider></v-divider>
            <v-card-text class="text-center">
              <span>{{savedSchool.internationalExamsNotes}}</span>
            </v-card-text>
          </v-card>

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkInternationalExamsMixin from '@/mixins/requirementchecks/checkinternationalexamsmixin'
  export default {
    mixins: [userMixins,checkInternationalExamsMixin],
    props: ['savedSchool'],
    data() {
      return {

      }
    },
  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}
.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}

</style>





// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/InternationalExams.vue